import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Observable, of } from 'rxjs';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';
import { Document } from '../../../document-data/document.model';
import { Schedule } from '../../../document-data/sub-models/schedule.model';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { IRouter } from '../../../shared/interfaces/router.interface';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { RecentlyEditedListItemBuilder } from './recently-edited-list-item.builder';
import { distinctUntilChanged } from 'rxjs/operators';
import { InvoiceDataStore } from '../../../invoice-data/invoice-data.store';

@Component({
  selector: 'app-recently-edited-list-item',
  templateUrl: './recently-edited-list-item.component.html',
  styleUrls: ['./recently-edited-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [RecentlyEditedListItemBuilder],
})
export class RecentlyEditedListItemComponent implements OnInit {
  @Input() recentlyEditedDocument: Document;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() featureToggles: Toggles;
  @Input() enableRecurring: boolean;

  viewDocumentRoute: IRouter;
  mainTranslationParams: any;
  documentType: DocumentTypesEnum;
  documentSchedule$: Observable<Schedule>;

  constructor(
    private _recentlyEditedListItemBuilder: RecentlyEditedListItemBuilder,
    private _invoiceDataStore: InvoiceDataStore
  ) {}

  ngOnInit() {
    this.viewDocumentRoute = this._recentlyEditedListItemBuilder.buildViewDocumentRoute(
      this.recentlyEditedDocument,
      this.trackingScreenName
    );
    this.documentType = this.recentlyEditedDocument.documentType;
    this.mainTranslationParams = this._recentlyEditedListItemBuilder.buildMainTranslationParams(
      this.recentlyEditedDocument
    );

    this.documentSchedule$ =
      this.recentlyEditedDocument.documentType === DocumentTypesEnum.invoice
        ? this._invoiceDataStore
            .getSchedulesByInvoiceId(this.recentlyEditedDocument.id)
            .pipe(distinctUntilChanged((a, b) => a && a.equals(b)))
        : of(null);
  }
}
